<template>
  <header
    id="site-header"
    class="header"
  >
    <div class="page-title">
      <h6>AREAS</h6>
    </div>


    <div class="header-content-wrapper">
      <div class="control-block">
        <div class="author-page author vcard inline-items more">
          <div class="author-thumb">
            <img
              alt="author"
              :src="imgNico"
              class="avatar"
            >
            <span class="icon-status" />
          </div>
          <a
            href="#"
            class="author-name fn"
          >
            <div class="author-title">{{ user.username }}
              <!-- classes: sprite-icon olymp-dropdown-arrow-icon -->
              <app-icon
                name="olymp-dropdown-arrow-icon"
                color="gray"
                size="large"
              />
            </div>
            <span class="author-subtitle">HOME APP</span>
            <button
              class="logout"
              @click="onLogout"
            >Logout</button>
          </a>
        </div>
      </div>
    </div>
  </header>
</template>

<script>

import imgNico from '../../../../static/img/nico-profile.jpg'
import AppIcon from "./AppIcon";

export default {
  name: 'HeaderAllAreas',
  components: { AppIcon },
  props: {
    user: {
      type: Object,
      default: function () { return {} }
    },
    ppa: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      app: this.ppa,
      // apps: ['personal', 'familial', 'financial', 'mental', 'physical', 'social', 'spiritual', 'vocational'],
      imgNico: imgNico
    }
  },
  computed: {
    auth () {
      return this.$store.getters['account/isAuthenticated']
    }
  },
  methods: {
    onLogout () {
      this.$store.dispatch('account/logout')
    },
    switchApp() {
      this.$store.dispatch('account/logout', this.app)
    }
  }
}
</script>
